import css from "@css/modules/HottestDeals.module.scss"
import { pointOnContractYearsString } from "@components/Listings/listings-page-utils"
import React, { HTMLAttributes } from "react"
import cn from "classnames"
import { useDealsContext } from "../context"
import { Tooltip } from "antd"
import { useMediaQuery } from "@utils/hooks/useMediaQuery"

type CellWithOrderProps = {
    orderField: string
} & HTMLAttributes<HTMLDivElement>

function CellWithOrder({ orderField, ...rest }: CellWithOrderProps) {
    const { sort, setState } = useDealsContext()
    const key = orderField + ":"
    const updateOrder = () => {
        const direction = sort.startsWith(key) ? (sort.endsWith("desc") ? "asc" : "desc") : "desc"
        setState({ sort: `${key}${direction}` })
    }
    const dir = sort.startsWith(key) ? (sort.endsWith("desc") ? "ascending" : "descending") : "descending"
    const title = `Click to sort ${dir}`
    const isActiveTop = sort.startsWith(key) && sort.endsWith("asc")
    const isActiveBottom = sort.startsWith(key) && sort.endsWith("desc")
    return (
        <Tooltip placement="top" title={title}>
            <div {...rest} className={cn(css.gridHeaderWithSort, rest.className)} onClick={() => updateOrder()}>
                {rest.children}
                <span className={cn(css.sortArrow, { [css.activeTop]: isActiveTop, [css.activeBottom]: isActiveBottom })} />
            </div>
        </Tooltip>
    )
}

export function GridHeader() {
    const isMobile = useMediaQuery("(max-width: 991px)")
    if (isMobile) return null
    return (
        <div className={css.gridHeaderWrap}>
            <div className={cn(css.gridHeader, css.centerCell)}>Rank</div>
            <CellWithOrder orderField="stars">Star</CellWithOrder>
            <div className={css.gridHeader}>Resort</div>
            <CellWithOrder orderField="price_per_point">$/pt</CellWithOrder>
            <CellWithOrder orderField="points_on_contract">Pts.</CellWithOrder>
            <div className={css.gridHeader}>
                Pts. Available <br />
                {pointOnContractYearsString}
            </div>
            <CellWithOrder orderField="use_month">Month</CellWithOrder>
            <CellWithOrder orderField="price">Price</CellWithOrder>
            <div className={css.gridHeader}>Status</div>
            <CellWithOrder className={css.hiddenOnMobile} orderField="parsed_date">
                Date Listed
            </CellWithOrder>
            <CellWithOrder className={cn(css.centerCell, css.hiddenOnMobile)} orderField="parsed_date">
                Days On Market
            </CellWithOrder>
            <CellWithOrder orderField="listing_popularity.totalViews">
                Popularity <br />
            </CellWithOrder>
        </div>
    )
}
